// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icon[data-v-6dc4c09b] {\n  color: var(--magic-light, #fff);\n}\n@media (min-width: 1024px) {\n  .icon[data-v-6dc4c09b] {\n    color: var(--magic-tertiary, #141f33);\n  }\n}", ""]);
// Exports
module.exports = exports;
